/* eslint-disable import/no-dynamic-require */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  Spin,
  Typography,
  message,
} from 'antd';
import {
  MailOutlined,
  LockOutlined,
} from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import { defSigob, themesAsArray } from 'themes';
import { getCatalogoDePadrones, getEstadosGlobales } from 'api/catalogos';
import { getLlavesDePredio } from 'api/catastro/llavesDePredios';
import { CLEAN, SET_CORTE, SET_THEME } from 'store/reducers/app';
import { LOGIN, LOGOUT } from 'store/reducers/auth';
import { getUserInfo, login } from 'api/usuarios/auth';
import styled from 'styled-components';
import { CLEAR } from 'store/reducers/catalogs';
import { CLEAN_CAJA } from 'store/reducers/caja';

const { Title, Text } = Typography;
const ENV_NAME = process.env.REACT_APP_ENV_NAME || 'migob';
const logo = require(`../../../assets/${ENV_NAME}/logo.png`);
const bg = require(`../../../assets/${ENV_NAME}/bg.png`);

const styles = {
  migob: {
    bgColor: '#eef3f7',
    fiColor: '',
    footerBg: '#184759',
    btnColor: '#184759',
    linkBtnColor: '#D2B25B',
    linkBtnActiveColor: '#184759',
    tittleColor: '#FFFFFF',
    txtShaddow: '',
  },
  nayarit: {
    bgColor: '#4F494C',
    fiColor: '#FFFFFF',
    footerBg: '#4F494C',
    btnColor: '#6C3440',
    linkBtnColor: '#FFFFFF',
    linkBtnActiveColor: '#6C3440', // no lika
    tittleColor: '#FFFFFF',
    txtShaddow: '',
  },
  iprovinay: {
    bgColor: '#4F494C',
    fiColor: '#FFFFFF',
    footerBg: '#4F494C',
    btnColor: '#6C3440',
    linkBtnColor: '#FFFFFF',
    linkBtnActiveColor: '#6C3440', // no lika
    tittleColor: '#FFFFFF',
    txtShaddow: '',
  },
  repuve: {
    bgColor: '#4F494C',
    fiColor: '#FFFFFF',
    footerBg: '#4F494C',
    btnColor: '#6C3440',
    linkBtnColor: '#FFFFFF',
    linkBtnActiveColor: '#6C3440', // no lika
    tittleColor: '#FFFFFF',
    txtShaddow: '',
  },
  arcos: {
    bgColor: '#4F494C',
    fiColor: '#FFFFFF',
    footerBg: '#4F494C',
    btnColor: '#6C3440',
    linkBtnColor: '#FFFFFF',
    linkBtnActiveColor: '#6C3440', // no lika
    tittleColor: '#FFFFFF',
    txtShaddow: '',
  },
  juarez: {
    bgColor: '#79898F',
    fiColor: '#FFFFFF',
    footerBg: 'transparent',
    btnColor: '#55283e',
    linkBtnColor: '#FFFFFF',
    linkBtnActiveColor: '#5F2A46',
    tittleColor: '#5F2A46',
    txtShaddow: '0px 4px 4px rgba(255, 255, 255, 0.25)',
  },
  oaxaca: {
    bgColor: '#79898F',
    fiColor: '#FFFFFF',
    footerBg: 'transparent',
    btnColor: '#55283e',
    linkBtnColor: '#FFFFFF',
    linkBtnActiveColor: '#5F2A46',
    tittleColor: '#5F2A46',
    txtShaddow: '0px 4px 4px rgba(255, 255, 255, 0.25)',
  },
  tlajomulco: {
    bgColor: '#EBCFB9',
    fiColor: '#FFFFFF',
    btnColor: '#ff5526',
    linkBtnColor: '#002E0A',
    linkBtnActiveColor: '#ff5526',
    txtShaddow: '',
    backgroundSize: '1000px',
  },
  navojoa: {
    bgColor: '#4F494C',
    fiColor: '#FFFFFF',
    footerBg: '#4F494C',
    btnColor: '#6C3440',
    linkBtnColor: '#FFFFFF',
    linkBtnActiveColor: '#6C3440', // no lika
    tittleColor: '#FFFFFF',
    txtShaddow: '',
  },
}[ENV_NAME];

const footerTitle = {
  repuve: 'PLATAFORMA INTEGRAL REPUVE',
  arcos: 'PLATAFORMA INTEGRAL ARCOS',
}[ENV_NAME] || 'Sistema Integral de Recaudación';

const Login = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    message.destroy();
    setLoading(true);
    const loginData = await login(values);
    if (loginData) {
      const userInfo = await getUserInfo(loginData.access);
      if (userInfo) {
        const { entidad, roles, corte } = userInfo;
        delete userInfo.entidad;
        delete userInfo.roles;
        delete userInfo.corte;
        dispatch({
          type: LOGIN,
          payload: {
            token: loginData.access,
            refreshToken: loginData.refresh,
            user: { ...userInfo },
            lastLogin: loginData.last_login,
            roles,
            entidad,
            periodoFiscalSelected: entidad.periodo_fiscal_vigente,
          },
        });
        dispatch({
          type: SET_CORTE,
          payload: corte,
        });
        const theme = themesAsArray.find((t) => t.name === userInfo.tema) || defSigob;
        dispatch({
          type: SET_THEME,
          payload: theme,
        });
        const config = { authorization: `Bearer ${loginData.access}` };
        await getEstadosGlobales(config);
        await getLlavesDePredio({}, config);
        await getCatalogoDePadrones({}, config);
      } else {
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  };

  const rules = {
    email: [{ type: 'email', required: true }],
    password: [{ required: true }],
  };

  useEffect(() => {
    dispatch({ type: LOGOUT });
    dispatch({ type: CLEAN });
    dispatch({ type: CLEAR });
    dispatch({ type: CLEAN_CAJA });
  }, []);

  return (
    <Container
      align="center"
      justify="end"
      className="container-login"
    >
      <Footer>
        <Title
          style={{
            fontWeight: 'bold',
            marginBottom: 15,
            color: styles.tittleColor,
            textShadow: styles.txtShaddow,
          }}
          level={ENV_NAME !== 'repuve' ? 2 : 5}
        >
          {footerTitle}
        </Title>
      </Footer>
      <Col xs={0} sm={0} md={18} className="background-container" />
      <LoginFormWrapper xs={24} sm={24} md={6}>
        <Spin tip="Cargando..." spinning={loading} style={{ width: '100%', height: '100%' }}>
          <LoginFormContainer md={24} sm={16}>
            <Row>
              <img
                src={logo}
                width="230"
                alt="logo"
              />
            </Row>
            <br />
            {ENV_NAME === 'migob' && (
              <Title
                style={{
                  fontWeight: 'bold',
                  color: 'gray',
                }}
                level={2}
              >
                Bienvenido
              </Title>
            )}
            <br />
            <Form
              name="login"
              layout="vertical"
              form={form}
              onFinish={onFinish}
            >
              <Form.Item
                name="email"
                rules={rules.email}
                label="Correo"
              >
                <Input prefix={<MailOutlined />} />
              </Form.Item>
              <Form.Item
                name="password"
                rules={rules.password}
                label="Contraseña"
              >
                <Input.Password placeholder="Introduzca Contraseña" prefix={<LockOutlined />} />
              </Form.Item>

              <Form.Item style={{ height: 32, marginBottom: 0 }}>
                <Button
                  type="link"
                  style={{ width: '100%', textAlign: 'right' }}
                  className="auth-button"
                  onClick={() => history.push('/recuperar-contrasena')}
                >
                  ¿Olvidó su contraseña?
                </Button>
              </Form.Item>

              <Form.Item style={{ marginBottom: 0 }}>
                <Button
                  className="auth-button"
                  htmlType="submit"
                  shape="round"
                  disabled={loading}
                  block
                >
                  Iniciar sesión
                </Button>
              </Form.Item>
            </Form>
            <Text className="version">
              Ver.
              {process.env.REACT_APP_VERSION}
            </Text>
          </LoginFormContainer>
        </Spin>

      </LoginFormWrapper>
    </Container>
  );
};

const Footer = styled(Col)`
  display: none;
  position: absolute;
  left: 0;
  bottom: 0;
  background-color: transparent;
  opacity: .8;
  width: 75%;
  height: 110px;
  z-index: 0;
  background-color: ${styles.footerBg};
  z-index: 2;

  .ant-typography {
    color: #FFFFFF;
    line-height: 110px;
    font-size: xx-large;
    text-align: center;
  }

  @media only screen and (min-height: 700px), (min-width: 1000px) {
    display: unset;
  }

  @media only screen and (max-width: 767px) {
    width: 100%;
  }
`;

const LoginFormWrapper = styled(Col)`
  z-index: 3;
  @media only screen and (max-height: 700px) and (max-width: 1000px) {
    width: 100vw !important;
    height: calc(100vh - 110px) !important;
  }

  @media only screen and (max-height: 700px) and (max-width: 1000px) {
    height: 100vh !important;
  }
`;

const LoginFormContainer = styled(Col)`
  border-radius: 12px;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background-color: ${styles.bgColor} !important;

  @media only screen and (min-width: 768px) {
    border-radius: 0;
  }

  #login {
    padding: 0 15px;
    width: 100%;
    max-width: 300px;
  }

  .ant-form-vertical .ant-form-item-label>label {
    height: 22px;
    text-transform: capitalize;
    color: ${styles.fiColor};
  }
    
  .version {
    position: absolute;
    bottom: 10px;
    right: 10px;
 }
`;

const Container = styled(Row)`
  height: 100vh;
  background-color: #eef3f7 !important;
  overflow: hidden;
  .background-container{
    background-size: cover;
    background-image: url(${bg});
    background-position: center 0;
    z-index: 1;
  }

  .ant-spin-nested-loading>div>.ant-spin {
    max-height: 100vh !important;
  }

  .ant-spin-blur {
    opacity: 1;
  }

  .ant-spin-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .flex {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .auth-button:not(.ant-btn-link) {
    background-color: ${styles.btnColor} !important;
    color: #FFFFFF !important;

    &:hover {
      border: none !important;
    }
  }

  .auth-button.ant-btn-link * {
    color: ${styles.linkBtnColor} !important;
  }
  .auth-button.ant-btn-link:hover * {
    color: ${styles.linkBtnActiveColor} !important;
  }
`;

export default Login;
